// To make Intercepter Work We need to Import the HttpClientModule into our application in app
import { Injectable } from "@angular/core";
import { tap } from "rxjs/operators";
import {
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpInterceptor,
    HttpResponse,
    HttpErrorResponse,
    HttpHeaderResponse,
    HttpHeaders
} from "@angular/common/http";
import { Observable } from "rxjs/Observable";

@Injectable()
export class TokenInterceptorService implements HttpInterceptor {
    httpHeader: HttpHeaders;
    constructor() {
        this.httpHeader = new HttpHeaders();
    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        let contentType = 'application/json';
        const token = localStorage.getItem('token');
        // if (request.url.includes('contentDownload')) {
        //     contentType = 'application/json';
        // } 
        const updatedRequest = request.clone({
            headers: new HttpHeaders()
                .set('Authorization', `Bearer ${token}`)
                .set('Content-Type', contentType)
                .set('Accept', '*/*')

        });

        if (request.url.includes('instantDownload')) {
            // updatedRequest.headers.append('response-type', 'blob');
        }

        return next.handle(updatedRequest).pipe(
            tap(
                event => {
                    if (event instanceof HttpResponse) {
                        // console.log("api call success :", event);
                    }
                },
                error => {
                    if (event instanceof HttpResponse) {
                        // console.log("api call error :", event);
                    }
                }
            )
        );
    }
}



// WEBPACK FOOTER //
// ./public/app/_services/token-interceptor.service.ts